export enum StepFunctionEndpointOrCustomOptions {
    Endpoint = 'endpoint',
    Custom = 'custom'
}
